import { render, staticRenderFns } from "./MainDetails.vue?vue&type=template&id=66a0d404&"
import script from "./MainDetails.vue?vue&type=script&lang=js&"
export * from "./MainDetails.vue?vue&type=script&lang=js&"
import style0 from "./MainDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports